import React from 'react';

let SearchBar = ({ updateFilter }) => (
	<div className="row">
		<div className="twelve columns">
			<input 
				type="text" 
				className="u-full-width" 
				placeholder="Search by name..." 
				style={({
					marginBottom: '0.5em'
				})} 
				onChange={event => updateFilter(event.target.value)}
				/>
		</div>
	</div>
);

export default SearchBar;


/** WEBPACK FOOTER **
 ** C:/Users/Lewis/Develop/redux-data-table/app/components/search-bar.jsx
 **/